<template>
  <v-alert v-show="HasError" type="error" class="mb-0">
      {{Message}}
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex';

import namespace from '../store/namespace';

export default {
	name: 'Error',
	computed: {
		...mapGetters(namespace.ERROR, ['HasError', 'Message']),
	},
};
</script>
